// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__32t_V","Tabs__link":"Tabs_Tabs__link__cjmiZ","Tabs__link_active":"Tabs_Tabs__link_active__2_nJ1"};